import { useEffect, useRef, useState } from 'react'

export function useVersionCheck(intervalMs = 60_000) {
  const [updateAvailable, setUpdateAvailable] = useState(false)
  const initialVersion = useRef<string | null>(null)

  // Polling /version.json каждые intervalMs мс
  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' })
        if (!res.ok) return
        const data = await res.json() as { v: string | number }
        const v = String(data.v)
        if (!initialVersion.current) {
          initialVersion.current = v
        } else if (initialVersion.current !== v) {
          setUpdateAvailable(true)
        }
      } catch {
        // offline or missing file — ignore
      }
    }

    check()
    const id = setInterval(check, intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])

  // SW посылает 'SW_UPDATED' при активации новой версии через skipWaiting.
  // Задержка 2с: при перезагрузке через "Update" новая страница попадает в clients.matchAll()
  // той же самой активации и получает лишний SW_UPDATED — игнорируем его.
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if ((event.data as { type?: string })?.type === 'SW_UPDATED') {
        setUpdateAvailable(true)
      }
    }
    const t = setTimeout(() => {
      navigator.serviceWorker?.addEventListener('message', handler)
    }, 2000)
    return () => {
      clearTimeout(t)
      navigator.serviceWorker?.removeEventListener('message', handler)
    }
  }, [])

  return updateAvailable
}
